//import 'server-only'
import React from 'react';
import {decode} from 'html-entities';
const dictionaries = {
    en: () => import('./locales/en/translation.json').then((module) => module.default),
    fr: () => import('./locales/fr/translation.json').then((module) => module.default),
    de: () => import('./locales/de/translation.json').then((module) => module.default),
    es: () => import('./locales/es/translation.json').then((module) => module.default),
    it: () => import('./locales/it/translation.json').then((module) => module.default),
};
export async function getTranslator(storeCode){
    if(!storeCode) storeCode = 'it_IT';
    let locale = storeCode.split('_')[0];
    if(!dictionaries[locale]) locale= 'en';
    const dict = await dictionaries[locale]();
    return (key,params) => {

        if(!dict) return key;

        let tags = key.match(/<([^>]+)>/g);

        if(tags) {

            try {
                const [tokenizedKey, tokens] = tokenizeKey(key);

                const tokenizedPhrase = dict[tokenizedKey] || `${tokenizedKey}`;

                const parsedPhrase = parseTokenizedPhrase(tokenizedPhrase, tokens);

                return renderParts(createParts(parsedPhrase));
            }catch (e) {
                console.error(e);
                return key;
            }
        }




        return dict[key] || `${key}`;
    }
}
const parseTokenizedPhrase = (tokenizedPhrase, tokens) => {
    let phrase = tokenizedPhrase;
    tokens.map(token => {
        phrase = phrase.replace(`<${token.index}>`, `<${token.content}>`);
        phrase = phrase.replace(`</${token.index}>`, `</${token.name}>`);
        phrase = phrase.replace(`<${token.index}/>`, `<${token.name}/>`);
    });
    return phrase;
}
const tokenizeKey = (key) => {


    let tokens = [];

    let tags = key.match(/<([^>]+)>/gi);

    if(tags) {
        let openTag = null;
        let index = 1;
        tags.map(tag => {
            const tagName = tag.match(/<(?:\/)?([a-zA-Z]+)/)[1];
            const tagContent = tag.match(/<([^>]+)>/)[1];
            //if is open tag
            if (!tag.match(/<\/[^>]+>/)) {
                openTag = true;
                tokens.push({
                    index: index++,
                    name: tagName,
                    content: tagContent
                });

            } else {
                openTag = false;
            }
            for(let i = tokens.length - 1; i >= 0; i--){
                if(tokens[i].name === tagName){
                    if(tagName === 'br'){
                        key = key.replace(`<${tokens[i].name}/>`, `<${tokens[i].index}/>`);
                    }else {
                        key = key.replace(`<${openTag ? tokens[i].content : '/' + tokens[i].name}>`, `<${openTag ? '' : '/'}${tokens[i].index}>`);
                    }
                    break;
                }
            }


        });
    }

    return [key,tokens];

}
const createParts = (phrase) => {

    let retParts = [];

    // split phrase into parts by open and close tags
    let parts = phrase.split(/(<[^>]+>)/).filter(p => p !== '');


    let cursorPath = [];

    parts.map(part => {

        // if part is a tag
        if(part.match(/<[^>]+>/)) {
            // create new object
            const tagNameMatch = part.match(/<((?:\/)?[a-zA-Z]+)/);
            //console.log('tagNameMatch',tagNameMatch,part);
            if(!tagNameMatch || tagNameMatch.length<=1){
                return;
            }
            const tagName = tagNameMatch[1];

            //console.log('tagName',part.match(/<((?:\/)?[a-zA-Z]+)/));
            // if is open tag
            if(!part.match(/<\/[^>]+>/)) {

                const attrs = part.match(/([a-zA-Z]+)="([^"]+)"/g);
                let parsedAttrs = {};
                if(attrs) {
                    attrs.map(attr => {
                        const [key, value] = attr.split('=');
                        parsedAttrs[key] = value.replace(/"/g, '');
                    });
                }

                const node = {
                    name: tagName,
                    props: tagName !== 'br' ? parsedAttrs : {},
                    content: tagName !== 'br' ? [] : []
                };

                if(cursorPath.length === 0){
                    retParts.push(node);
                }else{
                    cursorPath[cursorPath.length - 1].content.push(node);
                }

                if(tagName!== 'br')
                    cursorPath.push(node);

            } else {

                cursorPath.pop();
            }

        }else{
            if(cursorPath.length === 0){
                retParts.push(part);
            }else{
                cursorPath[cursorPath.length - 1].content.push(part);
            }
        }

    });

    return retParts;

}
const renderParts = (parts) => {

    let res = [];

    parts.map((part,i) => {

        // if part is object
        if(typeof part === 'object') {
            // create new object
            const tagName = part.name;
            let attrs = part.props;
            const content = part.content;

            if(!attrs?.key){
                attrs.key = [`trans`,`part`,i, tagName, res.length].join('_');
            }

            res.push(React.createElement(tagName, attrs, tagName!=='br' ? renderParts(content) : null));

        }else{
            res.push(part);
        }

    });

    return React.createElement(React.Fragment, {}, res);

}
export function getPhrases(keys,translator){
    let phrases = [];
    keys.map((key) => {
        phrases.push({key: key, value:translator(key)});
    });
    return phrases;
}
export const usePhrase = (phrases) => {
    return (key) => {
        if(!phrases){
            //console.log('missing phrase',key);
            return `${key}`;
        }
        const phrase = phrases.find(p => p.key===key);
        //if(!phrase) console.log('missing phrase',key);
        return phrase ? phrase.value: `${key}`;
    }
}

